import Vue from 'vue';
import Vuex from 'vuex';
import {singleAccountSever, singleDocumentsSever} from "@/common/api-config";

Vue.use(Vuex);
const store = {
  namespaced: true,
  state: {
    redirectMap: {},
    hasRequestMap: false
  },
  mutations: {
    setRedirectMap(state, data) {
      state.redirectMap = data
    },
    setStatus(state, data) {
      state.hasRequestMap = data
    },
  },
  getters: {
    getRedirectMap: (state) => {
      return state.redirectMap
    },
    getStatus: (state) => {
      return state.hasRequestMap
    }
  },
  actions: {
    queryRedirectMap(context) {
      return new Promise((resolve, reject) => {
        singleDocumentsSever.queryRedirectMap().then((res) => {
          if (res.code === 0) {
            context.commit('setRedirectMap', res.data);
            context.commit('setStatus', true);
            resolve(res);
          } else {
            context.commit('setRedirectMap', {});
            context.commit('setStatus', false);
            reject(res);
          }
        })
      })
    }
  }
}

export default store

